<h1 mat-dialog-title>確認</h1>

<div mat-dialog-content>
  <form class="confirm-form" #confirmForm="ngForm">
    <label>{{keySet}}</label>
    <span>
      <button type="cancel" (click)="onCancel()" mat-raised-button>キャンセル</button>
      <button type="submit" (click)="onSubmit()" mat-raised-button color="primary">実行</button>
    </span>
  </form>
</div>